import { createLazyComponent, LazyAction, LazyModule, type LazyComponent } from 'owa-bundling';
import { isCalendarSchedulingDialogOpen } from 'owa-calendar-scheduling-dialog-store';
import type * as lazyIndex from './lazyIndex';

export const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "CalendarSchedulingDialog" */ './lazyIndex'),
    { name: 'CalendarSchedulingDialog' }
);

export type { GetSchedulingDraftProps } from './types/GetSchedulingDraftProps';

/**
 * Lazily requests a scheduling draft without persisting a task or opening calendar compose.
 * Use the email mode to ground the request in a specific message.
 */
export const lazyGetSchedulingDraft: LazyAction<
    typeof lazyIndex.getSchedulingDraft,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getSchedulingDraft);

/** Renders the scheduling dialog only when open; its bundle can be prefetched independently. */
export const CalendarSchedulingDialog: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.CalendarSchedulingDialog,
    undefined,
    undefined,
    {
        onlyImportIf: isCalendarSchedulingDialogOpen,
    }
);
